import React, { useCallback, useEffect, useState } from "react";
import "./SubscriptionDetailsTab.scss";

// image imports
import SubscriptionDetailsIcon1 from "assets/images/SubscriptionDetailsIcon1.png";
import SubscriptionDetailsIcon2 from "assets/images/SubscriptionDetailsIcon2.png";
import SubscriptionDetailsImg from "assets/images/SubscriptionDetails-img.png";
import CloseIcon from "assets/images/close-icon.svg";
import Input from "common/components/Input/Input";
import { fetchRequest } from "utils/restApiCleintAxios";
import { useTypedDispatch, useTypedSelector } from "store";
import Button from "common/components/Button";
import CrossPink from "assets/icons/components/crossPink.svg";
import { Modal } from "react-bootstrap";
import ModalCancelSubscription from "./ModalCancelSubscription";
import { updateUser } from "store/users/slice";
import DateIcon from "assets/images/date-icon.svg";
import { localStorageKeys } from "config/localStorageKeys";
import SubscriptionDetailsTabMobile from "./SubscriptionDetailsTabMobile";
import { showMobile } from "helpers/adaptation";

function SubscriptionDetailsTab() {
  const [showModal, setShowModal] = useState(false);
  const [showModalCancel, setShowModalCancel] = useState(false);
  const ctoken = useTypedSelector((store) => store.user.client.ctoken);
  const { client } = useTypedSelector((store) => store.user);
  const dipsatch = useTypedDispatch();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userInfoStr = localStorage.getItem(localStorageKeys.userInfo);
        let userInfoParse: any = {};
        if (userInfoStr) {
          userInfoParse = JSON.parse(userInfoStr);
        }

        const res = await fetchRequest("api/user/GetUserSubscription", {
          method: "post",
          data: {
            ctoken: userInfoParse?.ctoken
          }
        });

        localStorage.setItem(
          localStorageKeys.makeRequestSubscriptionDate,
          JSON.stringify({
            ...res?.data?.userDetails?.user?.subscription,
            date: new Date(new Date().setMinutes(new Date().getMinutes() + 1))
          })
        );

        dipsatch(
          updateUser({
            subscription: res.data?.userDetails?.user?.subscription
          })
        );
      } catch {
        //
      }
    };
    const getLocalSubscriptionStr = localStorage.getItem(
      localStorageKeys.makeRequestSubscriptionDate
    );
    let getLocalSusbscriptionParse: any = {};
    if (getLocalSubscriptionStr) {
      getLocalSusbscriptionParse = JSON.parse(getLocalSubscriptionStr);
    }
    if (
      !getLocalSusbscriptionParse?.date ||
      new Date(getLocalSusbscriptionParse?.date) < new Date()
    ) {
      fetchData();
    } else {
      dipsatch(
        updateUser({
          subscription: getLocalSusbscriptionParse
        })
      );
    }
  }, [dipsatch]);

  const onCancelSubscription = useCallback(async () => {
    try {
      await fetchRequest("api/user/CancelSubscription", {
        method: "post",
        data: {
          ctoken: ctoken
        }
      });
      setShowModal(false);
      setShowModalCancel(true);
    } catch {
      //
    }
  }, [ctoken]);

  return (
    <>
      {showMobile && (
        <SubscriptionDetailsTabMobile onCancelSubscription={() => setShowModal(true)} />
      )}
      {!showMobile && (
        <div className="SubscriptionDetailsTab-form-main">
          <div className="SubscriptionDetailsTab-modal-otr">
            <img className="SubscriptionDetails-img" src={SubscriptionDetailsImg} alt="img" />
            <div className="close-icon-otr">
              <img className="close-icon" src={CloseIcon} alt="img" />
            </div>
            <h3 className="SubscriptionDetails-heading">
              Are you sure you want to cancel the <br /> automatic charge?
            </h3>
            <div className="SubscriptionDetails-action-otr">
              <a href="" className="SubscriptionDetails-btn leave-btn">
                No, leave
              </a>
              <a href="" className="SubscriptionDetails-btn cancel-btn">
                Yes, cancel
              </a>
            </div>
          </div>
          <div className="SubscriptionDetailsTab-form-otr">
            <div className="PersonalInformation-otr">
              <div className="PersonalInfo-icon-otr">
                <img className="PersonalInfo-icon" src={SubscriptionDetailsIcon1} alt="icon" />
              </div>
              <h3 className="PersonalInfo-heading">פרטי המנוי</h3>
              <div className="PersonalInfo-Input-otr">
                <Input
                  value={client?.subscription?.expiration}
                  label="בתוקף עד"
                  placeholder="בתוקף עד"
                  disabled
                />
              </div>
              <div className="PersonalInfo-Input-otr">
                <Input label="מסלול" placeholder="מסלול" value={client?.subscription?.type} />
              </div>
              <div className="PersonalInfo-Input-otr">
                <Input label="חידוש" placeholder="חידוש" value={client?.subscription?.renew} />
              </div>
            </div>
            <div className="ChangePassword-otr">
              <div className="PersonalInfo-icon-otr">
                <img className="PersonalInfo-icon" src={SubscriptionDetailsIcon2} alt="icon" />
              </div>
              <h3 className="PersonalInfo-heading">מסלול מתחדש</h3>
              <div className="PersonalInfo-Input-otr InputDate" style={{ position: "relative" }}>
                <Input
                  value={client?.subscription?.nextPayment}
                  label="החיוב הבא בתאריך"
                  placeholder="לא פעיל"
                  disabled
                />
                <div style={{ position: "absolute", left: 20, top: 10 }}>
                  <img className="date-icon" src={DateIcon} alt="icon" />
                </div>
                {!!client?.subscription?.nextPayment && (
                  <div className="SubscriptionDetailsTab-action">
                    <input
                      className="save-changes-btn"
                      type="submit"
                      name="submit"
                      value="ביטול חידוש אוטומטי"
                      onClick={() => setShowModal(true)}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalCancelSubscription
        visible={showModal}
        onConfirm={onCancelSubscription}
        onClose={() => setShowModal(false)}
      />
      <Modal
        show={showModalCancel}
        onHide={() => setShowModalCancel(false)}
        backdrop="static"
        keyboard={false}
        centered
        animation={false}
        scrollable
        className="modal-change-password">
        <div
          style={{
            background: "#fff",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            flex: 1
          }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 10,
              position: "absolute",
              top: 40,
              left: 40
            }}>
            <div
              style={{ left: 20, top: 20, cursor: "pointer" }}
              onClick={() => setShowModalCancel(false)}>
              <img src={CrossPink} />
            </div>
          </div>
          <div
            style={{
              paddingLeft: 120,
              paddingRight: 120
            }}>
            <h1
              style={{
                color: "rgba(72, 30, 160, 1)",
                fontSize: 48,
                fontWeight: 700
              }}>
              המנוי המתחדש בוטל
            </h1>
            <Button
              text="אישור"
              style={{
                marginTop: 30,
                background: "rgba(255, 99, 96, 1)",
                height: 60,
                padding: 0,
                width: 400
              }}
              onClick={() => setShowModalCancel(false)}
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SubscriptionDetailsTab;
